import React from 'react';
import Icon from '../shared/Icon';

const VISIBILITY_OPTIONS = [
  ['active', 'Active'],
  ['archived', 'Archived'],
  ['all', 'All'],
];
const USAGE_OPTIONS = [
  ['all', 'All documents'],
  ['in', 'In a scenario'],
  ['out', 'Not in a scenario'],
];
const SORT_OPTIONS = [
  ['date_desc', 'Newest first'],
  ['date_asc', 'Oldest first'],
  ['name_asc', 'Name A–Z'],
  ['name_desc', 'Name Z–A'],
];

function FilterSelect({ label, value, options, onChange }) {
  return (
    <select className="resui-select library-select" aria-label={label} value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map(([v, text]) => <option key={v} value={v}>{text}</option>)}
    </select>
  );
}

/**
 * Search, the two filters, the sort and the view toggle. It stays mounted
 * through the empty and no-result states, so the search field keeps focus
 * and caret as the results filter in place, and whatever caused a no-result
 * state stays on screen with its value.
 */
function LibraryToolbar({ filters, view, onFilterChange, onViewChange, searchRef }) {
  return (
    <div className="library-toolbar">
      <div className="library-toolbar-left">
        <div className="library-search">
          <Icon name="magnifying-glass" size={14} className="library-search-icon" />
          <input
            ref={searchRef}
            type="text"
            className="resui-input library-search-input"
            placeholder="Search documents…"
            aria-label="Search documents"
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
          />
        </div>
        <FilterSelect label="Filter by visibility" value={filters.visibility} options={VISIBILITY_OPTIONS} onChange={(v) => onFilterChange('visibility', v)} />
        <FilterSelect label="Filter by scenario use" value={filters.usage} options={USAGE_OPTIONS} onChange={(v) => onFilterChange('usage', v)} />
        <FilterSelect label="Sort documents" value={filters.sort} options={SORT_OPTIONS} onChange={(v) => onFilterChange('sort', v)} />
      </div>
      <div className="library-view-toggle" role="group" aria-label="View">
        {[['grid', 'grid-four', 'Grid view'], ['list', 'list', 'List view']].map(([key, icon, label]) => (
          <button
            key={key}
            type="button"
            className={view === key ? 'is-active' : undefined}
            aria-pressed={view === key}
            aria-label={label}
            onClick={() => onViewChange(key)}
          >
            <Icon name={icon} size={18} />
          </button>
        ))}
      </div>
    </div>
  );
}

export default LibraryToolbar;
